import {useRcfaCompliance} from '@domain/rcfa'
import {getSystemTimezone} from '@hconnect/common/utils'
import {useMediaQuery, Theme} from '@mui/material'

import {useRcfaCompliancePageState} from '../hooks'
import {RcfaComplianceCardsView, RcfaComplianceTableView} from '../layout'
import {rcfaComplianceTimeRangeMapper, convertToLocationNodes} from '../mappers'

type Props = {
  titleSlot?: React.ReactNode
  aboveTitleSlot?: React.ReactNode
  onPlantItemClick: (plantId: string) => void
  inverted?: boolean
}

export const RcfaCompliancePage = ({
  titleSlot,
  aboveTitleSlot,
  onPlantItemClick,
  inverted = false
}: Props) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const {timeRange} = useRcfaCompliancePageState()
  const timezone = getSystemTimezone()

  const {from, to} = rcfaComplianceTimeRangeMapper(timezone, timeRange)

  const {data} = useRcfaCompliance(
    {
      from,
      to
    },
    {
      select: convertToLocationNodes,
      refetchOnMount: false // we are fetching data in the container, here we only need items for expanded state
    }
  )

  return isMobile ? (
    <RcfaComplianceCardsView
      titleSlot={titleSlot}
      aboveTitleSlot={aboveTitleSlot}
      data={data}
      onPlantItemClick={onPlantItemClick}
      inverted={inverted}
    />
  ) : (
    <RcfaComplianceTableView
      titleSlot={titleSlot}
      aboveTitleSlot={aboveTitleSlot}
      data={data}
      onPlantItemClick={onPlantItemClick}
      inverted={inverted}
    />
  )
}
